<template>
  <div>
    <p class="category-title mx-2 mb-2">My Learning</p>
    <Card v-if="!enrolledTrainings" class="d-flex justify-content-center">
      <loader-component></loader-component>
    </Card>
    <Card v-else>
      <div class="d-flex justify-content-end">
         <div class="d-flex tab-container gap-2 p-2 my-auto">
              <div :class="[(activetab=='')? 'active': '' ,'tab']" @click="getTraining('')">All</div>
              <div :class="[(activetab=='COMPLETED')? 'active': '' ,'tab']" @click="getTraining('COMPLETED')">Completed</div>
              <div :class="[(activetab=='IN_PROGRESS')? 'active': '' ,'tab']" @click="getTraining('IN_PROGRESS')">In Progress</div>
              <div :class="[(activetab=='NOT_YET_STARTED')? 'active': '' ,'tab']" @click="getTraining('NOT_YET_STARTED')">Not Yet Started</div>
          </div>
        <div class="col-3 p-2">
          <Input placeholder="Search by training name" type="text" v-model="trainingSearchTerm" />
        </div>
      </div>
      <hr class="my-0 mb-2" />
      <div class="row m-0" v-if="enrolledTrainings.length>0">
        <div class="col-3 mb-3" v-for="(training, index) in enrolledTrainings" :key="index" >
          <Card class="p-3 m-0">
            <img :src="training.trainingImg" v-if="training.trainingImg" class="training-img" />
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU"
              v-else
              class="training-img"
            />
            <div class="">
              <p class="my-0 course-title" v-tooltip="training.name">{{ training.name }}</p>
              <!-- <div class="d-flex justify-content-between"> -->
              <Badge
                class="badge-rounded badge-rounded-grey-outline my-2"
                :label="'Trainer : ' + training.trainer.name"
              />
              <Badge
                class="badge-rounded badge-rounded-grey-outline my-2 d-block"
                :label="'Completed Percentage : ' + getPercentage(training.totalNoOfTasks, training.completedTasks)"
              />
              <Button
                class="qb-btn qb-btn-primary-sm w-100 mt-2"
                @onClick="handleNavigation(training.id)"
                label="View Training"
              />
              <!-- </div> -->
            </div>
          </Card>
        </div>
      </div>
       <div v-else class="my-2">
          <div><p class="my-2 mb-2 grey-text text-center">No Enrolled Trainings Found in this category</p>
          <p  class="grey-text text-center my-2"><Button label="Go To All Trainings" class="qb-btn qb-btn-black-sm" @onClick="navigateToAllTrainings"/> </p></div>
        </div>
    </Card>
    
  </div>
</template>

<script>
import Button from "../components/ButtonComponent.vue";
import Badge from "../components/BadgeComponent.vue";
import Input from "../components/TextFieldComponent.vue";
import LoaderComponent from "../components/LoaderComponent.vue"
// import DropDown from "../components/DropDownSearchComponent.vue";
import Card from "../components/CardComponent.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: workSheetMapGetters, mapActions: workSheetMapActions } = createNamespacedHelpers("WorkSheet");
const { mapGetters: mapAuthGetters } = createNamespacedHelpers("Auth");

export default {
  name: "EnrolledTrainingPage",
  data() {
    return {
      trainingSearchTerm: "",
      activetab:""
    };
  },
  components: {
    Card,
    // DropDown,
    Badge,
    Input,
    Button,
    LoaderComponent
  },
  computed: {
    ...workSheetMapGetters({
      enrolledTrainings: "getEnrolledTrainings",
    }),
    ...mapAuthGetters({
      user: "getUser",
    }),
  },
  methods: {
    ...workSheetMapActions({
      getEnrolledTrainingList: "GET_ENROLLED_TRAININGS_BY_USER_ID",
    }),
    handleNavigation(id = "123") {
      this.$router.push({ name: "WorkSheetPage", params: { id } });
    },
    handleTrainingNavigation(name) {
      this.$router.push({ name });
    },
    getPercentage(totalTask, completedTask) {
      return [
        isNaN(Number(Math.round((completedTask / totalTask) * 100)))
          ? 0
          : Number(Math.round((completedTask / totalTask) * 100)),
      ];
    },
    getTraining(status){
      this.activetab=status
      this.getEnrolledTrainingList({ id: this.user.userId ,status});
    },
    navigateToAllTrainings(){
      this.$router.push("/training/catalog")
    }
  },
  watch: {
    trainingSearchTerm(name) {
      if (this.trainingSearchTerm) {
        this.$router.push({ name: "EnrolledTrainingPage", query: { searchTerm: name } });
        this.getEnrolledTrainingList({ name, id: this.user.userId,status:this.activetab });
      } else {
        this.$router.push({ name: "EnrolledTrainingPage" });
        this.getEnrolledTrainingList({ id: this.user.userId ,status:this.activetab});
      }
    },
  },
  created() {
    this.getEnrolledTrainingList({ id: this.user.userId ,status:this.activetab});
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.fa-users-rectangle {
  font-size: 30px;
  margin: auto;
}
.category-title {
  font-size: $font-size-xxl;
  font-weight: $font-weight-bold;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}
.course-title {
  font-size: $font-size-xxl;
  font-weight: $font-weight-normal-2;
  text-overflow: ellipsis;
  display: block;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
}
.catalogue-card {
  border-radius: $field-border-radius;
  border: 1px solid $light-300;
}
.course-img {
  border-radius: $field-border-radius;
  background-color: $light-300;
  width: 100px;
  height: 100px;
}
.training-img {
  width: 100%;
  min-height: 165px;
  max-height:100px;
  border-radius: $field-border-radius;
}
.tab {
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-2;
  width: fit-content;
  height:max-content;
  border-radius: $field-border-radius-high;
  padding: 3px 10px;
  text-decoration: none;
  background-color: $light-300;
  color: $dark-300;
}

.tab:hover {
  cursor: pointer;
}
.active{
  color: $light-300;
  background-color: $dark-300;
}
.grey-text{
  color: $light-500;
  cursor: pointer;
  font-size: $font-size-md;
  // font-weight:bold;
}
</style>
